import React from 'react';
import Card from '../../common/Card/Card';
import './WelcomeCard.css';

const WelcomeCard = ({ userName, tenantName }) => {
    return (
        <Card className="welcome-card">
            <p className="welcome-text">
                Willkommen im Regentra Cockpit {userName},
            </p>

            <p className="welcome-message">
                wenn in der Dialog Wolke ein „Haken" zu sehen ist, dann lohnt es sich vorbeizuschauen.
            </p>

            <br/>

            {tenantName && (
                <p className="tenant-info">
                    Sie arbeiten als: <strong>{tenantName}</strong>
                </p>
            )}
        </Card>
    );
};

export default WelcomeCard;